var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 41,
    viewBox: "0 0 33 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 33,
    height: 41,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAApCAYAAAC7t0ACAAAB3UlEQVRYhe3YT4hNURzA8c97HrFgZMhC2duKPbKRf5nIv0IWmkJSko2NkC0WVjRZ0VgodspGKdkRsfMvrKSJaTRmno5+p8btzRtvevexuN86nc7tnnO+nXN/p3t+tRVDr6COddiPfvw0eyajzIlxruJxu9EaqOEMLsSzLFDrUKMZZe6UdhpjNXbgZTuJ9SHwGjfwMTrPRiKtwFbsxnkswyBuYgDvppM4hVGcxXCHE7diaUjcw1Msxh5cxwF8KvZJ38JKjOBtFwQSi6Luj/oo7mMjLofUH6SVGAuZeV2SaBbqLziOJdiF79H+ljvUuzTxTLzBETzHIZyL6OmpROJFbM0HnMTp/PH3UiLxCIfxFRdxrGyJ6UL8QYTtBC6lSCpDIk8+0uad29gXgXGlUYJEPnFPYFNMVGQiyud0RJQh8QTvsX1KuLaiGYLjZUg8xBasiXYrkfxsM3aWIZF4FmUm+pJEr0O0yEL/4Jwo0vwfJH5TSWQqiUwlkakkMpVEppLIVBKZSiJTSWTqcTuejMtIrxkXEj8wv4v5iU5YLm5AQ7gWN+SxyFmVvU1p9ddib0oVNCKptS1dQrAh8gdJotPE2d+SfvOTxKroMJgkUtLsYKxEyistyHtVMndxC3d+AWjBWjdnPj3FAAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.fb0fc2ea4c55348c2c8a85dc5ccfce88.svg";
export { ForwardRef as ReactComponent };